import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ApiService } from '@core/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class StaticPagesDataService {
  isMock = environment.mock;
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  getStaticPage(staticPageSlug: string): Observable<string> {
    return this.http.get(
      `./assets/cgu/${staticPageSlug}.${this.translateService.currentLang}.html`,
      { responseType: 'text' }
    );
    // todo: en attente du endpoint
    // return this.apiService.get(`static-pages/${staticPageSlug}`, new HttpParams(), new HttpHeaders());
  }
}
